import React from 'react';
import PropTypes from 'prop-types';
// import { convertDate } from '../../../../helpers/prismicHelpers/PrismicHelpers';
import { dateConverter } from '../../../../helpers/dateHelpers';

export const BlogHero = (props) => {
    const {
        date,
        background,
        title,
        description,
        languagePrismic
    } = props;


    let styleBackground = {};
    background && (styleBackground = {
        backgroundImage: `url(${background})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
    });

    // const date_by_origin = convertDate(languagePrismic.lang, date);
    const date_by_origin = dateConverter(date, "LLLL");

    return (

        <section className="page-hero" data-aos>
            <div style={styleBackground} className="mask"></div>
            <div className="container">
                {title && <h1 className="heading-main">{title}</h1>}
                {description && <p className="body-copy">{description}</p>}
                {
                    date && languagePrismic.lang && (
                        <p className="body-copy">{date_by_origin}</p>
                    )
                }

            </div>
        </section>
    );
}

BlogHero.propTypes = {

    date: PropTypes.string,
    title: PropTypes.string,
    description: PropTypes.string,
    background: PropTypes.string,
    languagePrismic: PropTypes.object
}



// WEBPACK FOOTER //
// src/client/components/site/features/blogs/BlogHero.js